var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((parseInt(_vm.options.size)),function(number,index){return _c('v-text-field',{key:`${_vm.questionId}-${number}`,attrs:{"value":_vm.answers[index],"outlined":"","disabled":_vm.isReadSurvey || _vm.options.readonly},on:{"input":function($event){return _vm.onUpdateOneValue(index, $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }